export class TableRowReorderEvent<Item> {
  public constructor(
    public readonly item: Item,
    public readonly dragIndex: number,
    public readonly dropIndex: number,
  ) {}
}
